import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'st-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
})
export class ErrorsComponent {
  @Input() errors?: ValidationErrors | null = null;

  ngOnInit() {
    console.log('ErrorsComponent initialized with errors:', this.errors);
  }
}
